export default __webpack_public_path__ + "static/media/scooter.c5224c69.svg";